import { useField } from 'formik'
import React, { useState } from 'react'
import { twMerge } from 'tailwind-merge'
import { AnyObject, ObjectSchema } from 'yup'

export type RadioInputOption = { value: string; label: string; icon?: React.ElementType; selectable?: boolean }
interface StyledRadioInputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  name: string
  showError?: boolean
  options?: RadioInputOption[]
  schema?: ObjectSchema<AnyObject>
}
//JSX.IntrinsicElements["input"]
const StyledRadioInputField: React.FC<StyledRadioInputFieldProps> = ({
  className,
  label,
  options = [],
  schema,
  ...props
}) => {
  const [required, setRequired] = useState(false)
  const [field, meta] = useField(props.name)

  const { error } = meta
  return (
    <fieldset className={twMerge('mt-4', className)}>
      <legend className="sr-only">{label}</legend>

      <div className={className}>
        <label htmlFor={field.name} className={`block text-sm font-medium ${error ? 'text-red-500' : 'text-gray-700'}`}>
          {label}
          {required && <span className="ml-1 text-red-500">*</span>}
        </label>
        <div className="mt-1 flex flex-row">
          {options
            .filter((x) => x.selectable ?? true)
            .map((o, idx) => (
              <div
                key={`pm-${idx}`}
                className="mr-2 flex-row items-center rounded-md border-2 border-solid border-gray-300 bg-white px-2 py-2"
              >
                <label className="flex items-center space-x-2">
                  <input
                    type="radio"
                    {...field}
                    {...props}
                    value={o.value}
                    checked={field.value === o.value}
                    className="text-primary ring-primary ring-offset-primary"
                  />
                  <div className="flex flex-row items-center justify-center ">
                    {o.icon && (
                      <o.icon className="mr-2 cursor-pointer text-gray-500 duration-300 ease-in-out hover:text-gray-900" />
                    )}

                    <div>{o.label}</div>
                  </div>
                </label>
              </div>
            ))}
        </div>
      </div>
    </fieldset>
  )
}

export default StyledRadioInputField
